module.exports = __webpack_public_path__ + "static/media/btResult1.325c866a.png";